"use strict";
// Interface representing a power profile schedule without ids
Object.defineProperty(exports, "__esModule", { value: true });
